import { Link } from 'react-router-dom';

import { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

import { Card, CardContent } from '@/components/ui/card';

interface DashboardCardProps {
  title: string;
  description?: string;
  icon: LucideIcon;
  href: string;
  iconColor?: string;
}

const DashboardCard = ({
  title,
  description,
  icon: Icon,
  href,
  iconColor = 'text-primary',
}: DashboardCardProps) => {
  return (
    <Link
      to={href}
      target={href.startsWith('http') ? '_blank' : undefined}
      rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
      className='rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
    >
      <Card
        className={cn(
          'cursor-pointer transition-all duration-300',
          'shadow-lg hover:shadow-2xl',
          'hover:scale-105 hover:border-primary/50',
          'group relative overflow-hidden',
          'border-2',
          'h-full min-h-[280px]',
        )}
      >
        <CardContent className='flex flex-col items-center justify-center p-8 space-y-4 h-full'>
          <div
            className={cn(
              'rounded-full p-6 transition-all duration-300',
              'bg-primary/10 group-hover:bg-primary/20',
              'shadow-md group-hover:shadow-lg',
            )}
          >
            <Icon className={cn('h-12 w-12', iconColor)} />
          </div>

          <h3 className='text-2xl font-semibold text-center'>{title}</h3>

          {description && (
            <p className='text-sm text-muted-foreground text-center max-w-xs'>{description}</p>
          )}
        </CardContent>
      </Card>
    </Link>
  );
};

export default DashboardCard;
